import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { Retailer } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class RetailerService {

    static Retailers: Array<Retailer> = [];

    constructor(
        private apiService: ApiService
    ) {}

    reset(){  
        RetailerService.Retailers = [];
    }

    async loadRetailers(): Promise<Retailer[]> {
        let retailers: Array<Retailer> = [];
        let response = await this.apiService.get('store/retailers');
        if(response?.data){
            retailers = response?.data;
            retailers.sort(((a, b): number => {
                return (a.name > b.name) ? 1 : -1;
            }));
        }
        return retailers;
    }
}
